// Generated by purs version 0.14.1
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Debug = require("../Debug/index.js");
var Effect = require("../Effect/index.js");
var Haskell_Grammar = require("../Haskell.Grammar/index.js");
var Haskell_Lexer = require("../Haskell.Lexer/index.js");
var Nearley = require("../Nearley/index.js");
var AmbiguousParse = (function () {
    function AmbiguousParse(value0) {
        this.value0 = value0;
    };
    AmbiguousParse.create = function (value0) {
        return new AmbiguousParse(value0);
    };
    return AmbiguousParse;
})();
var ParseError = (function () {
    function ParseError() {

    };
    ParseError.value = new ParseError();
    return ParseError;
})();
var Ok = (function () {
    function Ok(value0) {
        this.value0 = value0;
    };
    Ok.create = function (value0) {
        return new Ok(value0);
    };
    return Ok;
})();
var niceWarning = function (nice) {
    return function (v) {
        return "AMBIGUOUS: " + nice(v.value0);
    };
};
var niceResult = function (v) {
    return function (v1) {
        if (v1 instanceof ParseError) {
            return "PARSE ERROR";
        };
        if (v1 instanceof Ok) {
            return v(v1.value0.result) + ("\x0a" + Data_Array.foldMap(Data_Monoid.monoidString)(niceWarning(v))(v1.value0.warnings));
        };
        throw new Error("Failed pattern match at Haskell.Parser (line 24, column 1 - line 24, column 60): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var checkAmbiguous = function (rs) {
    var v = Data_Array.uncons(rs);
    if (v instanceof Data_Maybe.Nothing) {
        return [  ];
    };
    if (v instanceof Data_Maybe.Just) {
        return Debug.trace()({
            ambiguous: v.value0
        })(function (v1) {
            return [ new AmbiguousParse(v.value0.head) ];
        });
    };
    throw new Error("Failed pattern match at Haskell.Parser (line 49, column 21 - line 51, column 66): " + [ v.constructor.name ]);
};
var parse = function (s) {
    return function __do() {
        var p = Nearley.mkParser(Haskell_Grammar.grammar)();
        var loop = function (r) {
            if (r.ok) {
                return function __do() {
                    var r2 = Nearley.getResults(p)();
                    return Debug.trace()(r2)(function (v) {
                        return Control_Applicative.pure(Effect.applicativeEffect)(r2);
                    })();
                };
            };
            if (r.isParserError) {
                return Debug.trace()(r)(function (v) {
                    return Control_Bind.bind(Effect.bindEffect)(Nearley.runParser(p)(Haskell_Lexer.Retry.value))(loop);
                });
            };
            if (Data_Boolean.otherwise) {
                return Debug.trace()(r)(function (v) {
                    return Control_Applicative.pure(Effect.applicativeEffect)([  ]);
                });
            };
            throw new Error("Failed pattern match at Haskell.Parser (line 38, column 7 - line 40, column 49): " + [ r.constructor.name ]);
        };
        var rs = Control_Bind.bind(Effect.bindEffect)(Nearley.runParser(p)(new Haskell_Lexer.Feed(s)))(loop)();
        var v = Data_Array.uncons(rs);
        if (v instanceof Data_Maybe.Nothing) {
            return ParseError.value;
        };
        if (v instanceof Data_Maybe.Just) {
            return new Ok({
                result: v.value0.head,
                warnings: checkAmbiguous(v.value0.tail)
            });
        };
        throw new Error("Failed pattern match at Haskell.Parser (line 42, column 3 - line 46, column 44): " + [ v.constructor.name ]);
    };
};
module.exports = {
    ParseError: ParseError,
    Ok: Ok,
    AmbiguousParse: AmbiguousParse,
    niceResult: niceResult,
    niceWarning: niceWarning,
    parse: parse,
    checkAmbiguous: checkAmbiguous
};
